import { FormControl } from '@material-ui/core'
import React from 'react'

import { AreaLabelResponse } from 'src/api/gen'
import { SelectBox } from 'src/components/Select'

interface IProrationTimeSpentContentProps {
  areas: AreaLabelResponse[]
  disabled?: boolean | undefined
  prorationTimeSpentReportArea: string
  setProrationTimeSpentReportArea: React.Dispatch<string>
}

export const ProrationTimeSpentContent = function (props: IProrationTimeSpentContentProps) {
  return (
    <FormControl data-testid="proration-time-spent-content">
      <SelectBox
        disabled={props.disabled}
        value={props.prorationTimeSpentReportArea}
        onChange={(newArea: string) => {
          props.setProrationTimeSpentReportArea(newArea)
        }}
        data={props.areas}
      />
    </FormControl>
  )
}
